import React from 'react'
import MobileHeader from './mobileHeader'
import DesktopHeader from './desktopHeader'

interface HeaderProps {
  onSidebarToggle: () => void;
  isMobile: boolean;
  isSidebarOpen: boolean;
}

const Header: React.FC<HeaderProps> = ({ onSidebarToggle, isMobile, isSidebarOpen }) => {
  // Render either the MobileHeader or DesktopHeader based on the screen size
  return isMobile ? (
    <MobileHeader
      onSidebarToggle={onSidebarToggle}
      isSidebarOpen={isSidebarOpen}
    />
  ) : (
    <DesktopHeader />
  )
}

export default Header
